export const asideStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  width: 220,
  gap: 0.5,
  padding: 2,
  borderRadius: 2,
  border: `1px solid ${palette.divider}`,
  backgroundColor: palette.background.paper,
  boxShadow: palette.shadow?.s,
  alignSelf: 'flex-start',
});

export const asideTitleStyles = ({ palette }) => ({
  color: palette.text.secondary,
  textTransform: 'uppercase',
  marginBottom: 0.5,
});

export const statRowStyles = ({ palette }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  paddingY: 1,
  borderTop: `1px solid ${palette.divider}`,
});

export const statValueStyles = {
  fontVariantNumeric: 'tabular-nums',
};
